import { ChartBar, Home, Tag, Lightbulb, Inbox, Globe, CheckCircle, Wrench, ChartPie, BookOpen, Camera, Cog, FileText, Building, Users, Mail, CircleHelp, Link, ShieldCheck, Building2Icon, MessagesSquare } from "lucide-react";

import type { MenuItem } from "@/types";

// This is a temporary data structure until we implement the API call
const menuData = {
    success: true,
    data: [
        {
            id: "home",
            icon: Home,
            label: {
                nl: "Home",
                en: "Home",
                de: "Startseite",
                fr: "Accueil",
            },
            path: "/",
            sequence: 1,
        },
        {
            id: "relation-management",
            icon: ChartBar,
            label: {
                nl: "Relatiebeheer",
                en: "Account Management",
                de: "Beziehungsmanagement",
                fr: "Gestion des relations",
            },
            path: "/account-management",
            sequence: 2,
            subItems: [
                {
                    id: "customers",
                    icon: Building2Icon,
                    label: {
                        nl: "Klanten",
                        en: "Customers",
                        de: "Kunden",
                        fr: "Clients",
                    },
                    path: "/account-management/customers",
                    sequence: 1,
                },
                {
                    id: "brands",
                    icon: Tag,
                    label: {
                        nl: "Merken",
                        en: "Brands",
                        de: "Marken",
                        fr: "Marques",
                    },
                    path: "/account-management/brands",
                    sequence: 2,
                },
                {
                    id: "boost-supplier",
                    icon: Lightbulb,
                    label: {
                        nl: "Leveranciers",
                        en: "Suppliers",
                        de: "Lieferanten",
                        fr: "Fournisseurs",
                    },
                    path: "/account-management/boost-your-supplier",
                    sequence: 3,
                },
                {
                    id: "upload-certificates",
                    icon: ShieldCheck,
                    label: {
                        nl: "Upload certificaten",
                        en: "Upload certificates",
                        de: "Zertifikate hochladen",
                        fr: "Télécharger des certificats",
                    },
                    path: "/account-management/upload-certificates",
                    sequence: 4,
                },
            ],
        },
        {
            id: "product-management",
            icon: Inbox,
            label: {
                nl: "Productbeheer",
                en: "Product management",
                de: "Produktmanagement",
                fr: "Gestion des produits",
            },
            path: "/product-management",
            sequence: 4,
            subItems: [
                {
                    id: "ps-impact-score",
                    icon: Globe,
                    label: {
                        nl: "PS Impact Score",
                        en: "PS Impact Score",
                        de: "PS Impact Score",
                        fr: "PS Impact Score",
                    },
                    path: "/product-management/ps-impact-score",
                    sequence: 1,
                },
                {
                    id: "maxima",
                    icon: CheckCircle,
                    label: {
                        nl: "Maxima",
                        en: "Maxima",
                        de: "Maxima",
                        fr: "Maxima",
                    },
                    path: "/product-management/maxima",
                    sequence: 2,
                },
                {
                    id: "images",
                    icon: Camera,
                    label: {
                        nl: "Afbeeldingen",
                        en: "Images",
                        de: "Bilder",
                        fr: "Images",
                    },
                    path: "/product-management/images",
                    sequence: 3,
                },
                {
                    id: "excel-import",
                    icon: Cog,
                    label: {
                        nl: "Excel import",
                        en: "Excel import",
                        de: "Excel import",
                        fr: "Importation Excel",
                    },
                    path: "/product-management/excel-import",
                    sequence: 4,
                },
                {
                    id: "data-entry",
                    icon: Wrench,
                    label: {
                        nl: "DataEntry",
                        en: "DataEntry",
                        de: "Dateneingabe",
                        fr: "Entrée de données",
                    },
                    path: "/data-entry",
                    sequence: 5,
                },
            ],
        },
        {
            id: "data-integration",
            icon: ChartBar,
            label: {
                nl: "Data integratie",
                en: "Data integration",
                de: "Datenintegration",
                fr: "Intégration de données",
            },
            path: "/data-integration",
            sequence: 5,
            subItems: [
                {
                    id: "gs1-import-log",
                    icon: FileText,
                    label: {
                        nl: "GS1 import log",
                        en: "GS1 import log",
                        de: "GS1 Importlog",
                        fr: "Journal d'importation GS1",
                    },
                    path: "/data-integration/gs1-import-log",
                    sequence: 1,
                },
                {
                    id: "assortment-identification",
                    icon: CheckCircle,
                    label: {
                        nl: "Assortiment identificatie",
                        en: "Assortment identification",
                        de: "Sortimentidentifikation",
                        fr: "Identification de l'assortiment",
                    },
                    path: "/data-integration/assortment-identification",
                    sequence: 2,
                },
            ],
        },
        {
            id: "reports",
            icon: ChartPie,
            label: {
                nl: "Rapporten",
                en: "Reports",
                de: "Berichte",
                fr: "Rapports",
            },
            path: "/reports",
            sequence: 6,
        },
        {
            id: "maintenance",
            icon: Wrench,
            label: {
                nl: "Onderhoud",
                en: "Maintenance",
                de: "Wartung",
                fr: "Maintenance",
            },
            path: "/maintenance",
            sequence: 7,
            subItems: [
                {
                    id: "company-profile",
                    icon: Building,
                    label: {
                        nl: "Onderhoud bedrijf",
                        en: "Company maintenance",
                        de: "Unterhaltung des Unternehmens",
                        fr: "Maintenance de l'entreprise",
                    },
                    path: "/company/profile",
                    sequence: 1,
                },
                {
                    id: "company-users",
                    icon: Users,
                    label: {
                        nl: "Onderhoud gebruikers",
                        en: "User maintenance",
                        de: "Benutzerwartung",
                        fr: "Maintenance des utilisateurs",
                    },
                    path: "/company/users",
                    sequence: 2,
                },
                {
                    id: "companies",
                    icon: Building2Icon,
                    label: {
                        nl: "Bedrijven",
                        en: "Companies",
                        de: "Unternehmen",
                        fr: "Entreprises",
                    },
                    path: "/companies",
                    sequence: 3,
                },
            ],
        },
        {
            id: "content-management",
            icon: BookOpen,
            label: {
                nl: "Content beheer",
                en: "Content management",
                de: "Content-Management",
                fr: "Gestion de contenu",
            },
            path: "/content-management",
            sequence: 8,
            subItems: [
                {
                    id: "permalink",
                    icon: Link,
                    label: {
                        nl: "Permalink",
                        en: "Permalink",
                        de: "Permalink",
                        fr: "Permalink",
                    },
                    path: "/content-management/permalink",
                    sequence: 1,
                    subItems: [
                        {
                            id: "permalink-generator",
                            icon: Link,
                            label: {
                                nl: "Generator",
                                en: "Generator",
                                de: "Generator",
                                fr: "Générateur",
                            },
                            path: "/content-management/permalink",
                            sequence: 1,
                        },
                        {
                            id: "permalink-statistics",
                            icon: ChartBar,
                            label: {
                                nl: "Statistieken",
                                en: "Statistics",
                                de: "Statistiken",
                                fr: "Statistiques",
                            },
                            path: "/content-management/permalink/statistics",
                            sequence: 2,
                        }
                    ]
                },
                {
                    id: "digital-catalog",
                    icon: BookOpen,
                    label: {
                        nl: "Digitale catalogus",
                        en: "Digital catalog",
                        de: "Digitaler Katalog",
                        fr: "Catalogue numérique",
                    },
                    path: "/content-management/digital-catalog",
                    sequence: 2,
                },
                {
                    id: "message-template",
                    icon: Mail,
                    label: {
                        nl: "Berichten templates",
                        en: "Message templates",
                        de: "Nachrichtenvorlagen",
                        fr: "Modèles de messages",
                    },
                    path: "/content-management/message-template",
                    sequence: 3,
                },
                {
                    id: "helpdesk",
                    icon: CircleHelp,
                    label: {
                        nl: "Helpdesk",
                        en: "Helpdesk",
                        de: "Hilfe",
                        fr: "Support",
                    },
                    path: "/content-management/helpdesk",
                    sequence: 4,
                },
                {
                    id: "helpdesk-admin",
                    icon: MessagesSquare,
                    label: {
                        nl: "Helpdesk beheer",
                        en: "Helpdesk management",
                        de: "Hilfe",
                        fr: "Support",
                    },
                    path: "/content-management/helpdesk-admin",
                    sequence: 5,
                },
            ],
        },
    ],
};

// Export the menu items sorted by sequence
export const menuItems = menuData.data.sort((a, b) => a.sequence - b.sequence);

// Cache for menu items per user role
const menuCache = new Map<string, MenuItem[]>();

// This is a placeholder for the future API implementation
export const fetchMenuItems = async (userRole?: string): Promise<MenuItem[]> => {
    // If we have a cached version for this role, return it
    if (userRole && menuCache.has(userRole)) {
        return menuCache.get(userRole)!;
    }

    // TODO: Replace with actual API call
    // For now, we'll use the static data but filter based on role
    let filteredItems = [...menuItems];

    // Example role-based filtering (adjust according to your actual roles and requirements)
    if (userRole === 'admin') {
        // Admin sees everything
        filteredItems = menuItems;
    } else if (userRole === 'user') {
        // Regular users don't see maintenance items
        filteredItems = menuItems.filter(item => item.id !== 'maintenance');
    }

    // Cache the filtered items for this role
    if (userRole) {
        menuCache.set(userRole, filteredItems as MenuItem[]);
    }

    return filteredItems as MenuItem[];
};

// Function to clear the cache when needed (e.g., on logout)
export const clearMenuCache = () => {
    menuCache.clear();
};
